import React from 'react';
import { Briefcase, Code2, Palette, BarChart3, Users, Heart, Globe } from 'lucide-react';
import { PlaceholderPage } from '../components/PlaceholderPage';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Careers() {
  const roles = [{
    title: 'Senior Frontend Engineer',
    team: 'Engineering',
    location: 'Chennai / Remote',
    icon: Code2
  }, {
    title: 'Product Designer',
    team: 'Design',
    location: 'Chennai',
    icon: Palette
  }, {
    title: 'Data Analyst',
    team: 'Analytics',
    location: 'Remote',
    icon: BarChart3
  }, {
    title: 'Customer Success Manager',
    team: 'Customer Success',
    location: 'Chennai',
    icon: Users
  }];
  return <div className="w-full" data-id="element-272">
      <PlaceholderPage badgeText="CAREERS" badgeIcon={<Briefcase className="w-3.5 h-3.5" data-id="element-274" />} titleStart="Build the future" titleAccent="with us" subtitle="Join a team that's reimagining how businesses run. We're a tight-knit crew of designers, engineers, and operators based in Chennai — building tools used by hundreds of businesses across India." sections={[{
      icon: Heart,
      title: 'Mission-Driven',
      description: 'Work on problems that matter for thousands of growing businesses every single day.'
    }, {
      icon: Users,
      title: 'Small, Senior Team',
      description: 'No bureaucracy. High autonomy. Direct impact on every product decision.'
    }, {
      icon: Globe,
      title: 'Remote-Friendly',
      description: 'Chennai HQ, but we hire across India and the world for the right talent.'
    }]} data-id="element-273" />

      <section className="py-16 bg-slate-50" data-id="element-275">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-276">
          <div className="text-center mb-12" data-id="element-277">
            <h2 className="text-3xl md:text-4xl font-black mb-3" data-id="element-278">
              Open Positions
            </h2>
            <p className="text-slate-600" data-id="element-279">
              We're actively hiring for the following roles.
            </p>
          </div>
          <div className="space-y-4" data-id="element-280">
            {roles.map((role, i) => <motion.div key={role.title} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="bg-white rounded-2xl border border-slate-200 p-6 flex items-center justify-between gap-4 hover:shadow-md transition-all" data-id="element-281">
                <div className="flex items-center gap-4 min-w-0" data-id="element-282">
                  <div className="w-12 h-12 rounded-xl bg-blue-50 text-brand-blue flex items-center justify-center shrink-0" data-id="element-283">
                    <role.icon className="w-5 h-5" data-id="element-284" />
                  </div>
                  <div className="min-w-0" data-id="element-285">
                    <h3 className="font-bold text-slate-900 truncate" data-id="element-286">
                      {role.title}
                    </h3>
                    <p className="text-sm text-slate-500" data-id="element-287">
                      {role.team} • {role.location}
                    </p>
                  </div>
                </div>
                <Link to="/contact" className="shrink-0 inline-flex items-center gap-1.5 text-brand-blue font-bold hover:gap-2.5 transition-all" data-id="element-288">
                  Apply <ArrowRight className="w-4 h-4" data-id="element-289" />
                </Link>
              </motion.div>)}
          </div>
        </div>
      </section>
    </div>;
}